import { FC } from 'react';
import { DialogProps, Stack, IconButton } from '@mui/material';
import { StyledDialog, Title, Desc } from './styles';
import CloseIcon from '../../../assets/icons/X-icon.svg';
import Button from '../Button';
import { BLVD_TIMEBLOCK_API_ERROR, DEFAULT_ERROR_MESSAGE } from '../../../utils/common/error-messages';

interface ICustomDialog {
  isModalOpen: boolean;
  handleClose: () => void;
  width?: DialogProps['maxWidth'];
  padding?: string;
  errorTextValue?: string;
}

const CustomDialog: FC<ICustomDialog> = ({
  isModalOpen,
  handleClose,
  width = 'xs',
  padding = '24px',
  errorTextValue = '',
}) => {
  const errorMessage = errorTextValue === BLVD_TIMEBLOCK_API_ERROR;
  return (
    <StyledDialog open={isModalOpen} maxWidth={width} padding={padding}>
      <Stack direction='row' justifyContent='flex-end'>
        <IconButton onClick={handleClose}>
          <img src={CloseIcon} alt='popup close' />
        </IconButton>
      </Stack>
      <Title variant='h3'>{errorMessage ? BLVD_TIMEBLOCK_API_ERROR : 'Something Went Wrong'}</Title>
      {!errorMessage && <Desc variant='body1'>{DEFAULT_ERROR_MESSAGE}</Desc>}
      <Button
        variant='contained'
        fullWidth={false}
        onClick={handleClose}
        value='OK'
      />
    </StyledDialog>
  );
};

export default CustomDialog;
